import React, { useContext, useState } from "react";
import { LabelContext } from "../../assets/js/labelDataContext";

const OrderAddress = (props) => {
  const value = useContext(LabelContext);
  const address = value.labelInfo.address;
  const client = value.labelInfo.client;
  const [error, setError] = useState(null);
  
  const btnDisabled = true;
  const allFieldsOk = 
    address.city.length > 0 &&
    address.zipCode.length > 0 &&
    address.street.length > 0 &&
    address.line1.length > 0 &&
    client.firstName.length > 0 &&
    client.lastName.length > 0 &&
    client.phoneNumber >= 9;


    function isValidEmail(email) {
      return /\S+@\S+\.\S+/.test(email);
    }

    const handleSubmit = () => {   
      setError(null);
     // if (!allFieldsOk) err_text = "Uzupełnij Wszystkie wymagane pola!";
      //if (!isValidEmail(client.email)) err_text += "<br />"
      if (allFieldsOk && isValidEmail(client.email)) {
        value.nextPage();
      } else {
        setError('Uzupełnij wszystkie wymagane pola!');
      }
    };
    //const test = client.firstName > 0;
  return (
    <form>
      {error && <div className="order_form_errors"> {error}</div>}
      <div className="personal-data-box">
        <div className="row">

          {/* Client */}
          <div className="col-md-6">
            <h4>Dane osobowe</h4>
            <input
              placeholder="Imię"
              required
              onChange={value.setClientInfo("firstName")}
              value={client.firstName}
              className="form-control"
            />

            <input
              placeholder="Nazwisko"
              required
              onChange={value.setClientInfo("lastName")}
              value={client.lastName}
              className="form-control"
            />

            <input
              placeholder="Email"
              required
              type="email"
              onChange={value.setClientInfo("email")}
              value={client.email} 
              className="form-control"
            />

            <input
              placeholder="Nr telefonu"
              type="text"
              required
              onChange={value.setClientInfo("phoneNumber")}
              value={client.phoneNumber}
              className="form-control"
            />
          </div>

          <div className="col-md-6">
            <h4>Adres dostawy</h4>
            <input
              placeholder="Miejscowość"
              required
              onChange={value.setAddressInfo("city")}
              value={address.city}
              className="form-control"
            />
            <input
              placeholder="Kod pocztowy"
              required
              onChange={value.setAddressInfo("zipCode")}
              value={address.zipCode}
              className="form-control"
            />

            <input
              required
              placeholder="Ulica"
              onChange={value.setAddressInfo("street")}
              value={address.street}
              className="form-control"
            />
            <input
              required
              placeholder="Numer budynku"
              onChange={value.setAddressInfo("line1")}
              value={address.line1}
              className="form-control"
            />
            <input
              placeholder="Numer lokalu"
              onChange={value.setAddressInfo("line2")}
              value={address.line2}
              className="form-control"
            />
          </div>

          <div className="row w-100">
          <div className="col-12">
            <h4>Rabaty</h4>
            <input
                placeholder="Kod rabatowy"
                onChange={value.setClientInfo("promo_code")}
                value={client.promo_code}
                className="form-control"
            />
          </div>
        </div>

        </div>

        

        <div className="row w-100">
          <div className="col-12">
            <h4>Uwagi</h4>
            <textarea
                rows={"5"}
                placeholder="Dodatkowe informacje"
                onChange={value.setClientInfo("info")}
                value={client.info}
                className="form-control"
            />
          </div>
        </div>

        <div
          variant="contained"
          color="primary"
          aria-label="text primary button group"
          style={{ marginTop: 15 }}
        >
          <button onClick={() => value.prevPage()}
            className="btn-next">
            Wstecz
          </button>
          <button
            disabled={!btnDisabled}
            onClick={() => handleSubmit()}
            className="btn-next"
          >
            Dalej
          </button>
        </div>
      </div>
    </form>
    

  );
};
export default OrderAddress;